export default "__VITE_ASSET__CGqdlJyz__"